export type CheckInStatus = 'used' | 'auto' | 'expired' | 'unused' | 'locked'
type InventoryItemStatus = 'claimable' | 'claimed' | 'applied' | 'used' | 'expired'
type ActivationType = 'auto' | 'manual'
type BoostUnit = 'percentage' | 'fixed'

export interface ActiveDailyItem { 
  step: number; 
  status: CheckInStatus 
}
export interface DailyStreak {
  currentStep: number
  lastLoginAt?: Date
  lastBetAt?: Date
  nextLoginWindow?: TimeWindow
  nextBetWindow?: TimeWindow
  steps: DailyStreakStep[]
}

export interface DailyStreakStep {
  step: number
  reward: Reward
  received?: ReceivedItem
}

interface BaseReward {
  type: string
  subType: string
  quantity: number
  options: Record<string, unknown>
}

export interface BoosterReward extends BaseReward {
  type: 'inventory_item'
  subType: 'booster'
  options: {
    activationType: ActivationType
    boost: {
      value: number
      unit: BoostUnit
    }
  }
}

export type Reward = BoosterReward

export interface ReceivedItem {
  id: string
  status: InventoryItemStatus
}

export interface TimeWindow {
  start: Date
  end: Date
}

export const isBoosterReward = (item: Reward): item is BoosterReward => {
  return item.type === 'inventory_item' && item.subType === 'booster'
}